import { Loading } from "@/components/ui/loading";
import { useToast } from "@/hooks/use-toast";
import { supabase } from "@/lib/supabase";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { profile } = useAuth();
  const { toast } = useToast();
  const { t } = useTranslation(["auth", "common"]);

  useEffect(() => {
    const handleAuthCallback = async () => {
      try {
        // Get the session from the URL
        const { error } = await supabase.auth.getSession();

        if (error) {
          console.error("Auth callback error:", error);
          toast({
            title: t("common:status.error"),
            description: error.message,
            variant: "destructive"
          });
          navigate("/login");
          return;
        }

        if (!profile.anonymous) {
          navigate("/");
        } else {
          navigate("/login");
        }
      } catch (err) {
        console.error("Auth callback error:", err);
        toast({
          title: t("common:status.error"),
          description: "Authentication failed",
          variant: "destructive"
        });
        navigate("/login");
      }
    };

    handleAuthCallback();
  }, [navigate, toast, t, profile]);

  return <Loading text="Completing sign in..." />;
}
